module.exports = __webpack_public_path__ + "img/tawitech.a6a46be1.png";